import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class BigOrdersWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "home", title: "Home", href: "#top" },
            { icon: "shopping bag", title: "Big Orders", href: "/shop/orders?origin=Shopify" },
            { icon: "shop", title: "Shopify Orders", href: "/shop/shopify" },
            { icon: "plus circle", title: "Create Replacement", href: "/shop/create2" },
            {},
            { icon: "list alternate", title: "Beyond Analytics", href: "/analytics" },
            { icon: "th list", title: "Big Orders Report", href: "/shop/report?origin=Shopify&state=WaitingForInventory" },
            { icon: "server", title: "Webhook Log", href: "/shop/webhooks" },
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
